/*eslint-disable*/
import React from 'react'
import { Button, Modal, Header } from 'semantic-ui-react'

const DeleteModal = (props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            size="mini"
        >
            <Header>Notification</Header>
            <Modal.Content>
                <p>Are you sure you want to delete?</p>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.onClose} size="mini">Cancel</Button>
                <Button onClick={props.handleDelete} disabled={props.isloading ? true : false} color='blue' size="mini">Delete</Button>
            </Modal.Actions>
        </Modal>
    )

}

export default DeleteModal